import { render } from "./outsider.vue?vue&type=template&id=5db65541"
import script from "./outsider.vue?vue&type=script&lang=js"
export * from "./outsider.vue?vue&type=script&lang=js"

import "./outsider.vue?vue&type=style&index=0&id=5db65541&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__